var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("title",{"key":1},"logo_youtube_192px_clr"),React.createElement("path",{"d":"M180.32,53.36A22.12,22.12,0,0,0,164.76,37.7C151,34,96,34,96,34s-55,0-68.76,3.7A22.12,22.12,0,0,0,11.68,53.36C8,67.18,8,96,8,96s0,28.82,3.68,42.64A22.12,22.12,0,0,0,27.24,154.3C41,158,96,158,96,158s55,0,68.76-3.7a22.12,22.12,0,0,0,15.56-15.66C184,124.82,184,96,184,96S184,67.18,180.32,53.36ZM78,122.17V69.83L124,96Z","transform":"translate(-8 -34)","key":2})]);
}

Youtube.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 176 124"};

module.exports = Youtube;

Youtube.default = Youtube;
